import React, { useState, useRef } from "react";
import Button from "./Button";

//components
import Popup from "./Popup";

import {
  useForm
} from "react-hook-form";

import SocialMedia from "./SocialMedia";

//SVG's
import Instagram from "../svgs/Instagram";
import Facebook from "../svgs/Facebook";
import WhatsApp from "../svgs/WhatsApp";
import Telegram from "../svgs/Telegram";

const PopupSocialMedia = ({ trigger, setTrigger, setSelectedMedia }) => {

  const { register, handleSubmit } = useForm();

  const onSubmit = data => {
    setSelectedMedia(data.social_media);
  };

  return (
    <Popup title="Filtrar por rede social" trigger={trigger} setTrigger={setTrigger} >
      <div className="sm-body">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row-grid">
            <SocialMedia title="Facebook" name="social_media" value="Facebook" register={register}>
              <Facebook />
            </SocialMedia>

            <SocialMedia title="Instagram" name="social_media" value="Instagram" register={register}>
              <Instagram />
            </SocialMedia>

            <SocialMedia title="Whatsapp" name="social_media" value="Whatsapp" register={register}>
              <WhatsApp />
            </SocialMedia>

            <SocialMedia title="Telegram" name="social_media" value="Telegram" register={register}>
              <Telegram />
            </SocialMedia>
          </div>

          <div className="popup-footer">
            <button className="btn btn-primary" type="submit">Concluir</button>
            <button className="btn btn-light mr-20" type="submit" onClick={() => setTrigger(false)}>Cancelar</button>
          </div>
        </form>
      </div>
    </Popup>
  );
}

export default PopupSocialMedia;